export default __webpack_public_path__ + "static/Americana-Font-Regular-f0fab86c53a5cf545a4c85e7970dbf6c.woff";